$(function(){

    App.Seo =  {

        send: function(eventType, eventName){

            try {

                switch (eventType) {

                    case 'formSend':

                        switch (eventName) {

                            case 'brief':

                                dataLayer.push({'event':'Brief', 'eventCategory':'Brief', 'eventAction':'send'});

                                break;

                            case 'get_consultation':

                                dataLayer.push({'event':'Callback', 'eventCategory':'Callback', 'eventAction':'send'});

                                break;

                        }

                        break;

                    case 'socIconClick':

                        dataLayer.push({'event':'Social', 'eventCategory':'Social', 'eventAction':'click', 'eventLabel':eventName});

                        break;

                    case 'LK':

                        dataLayer.push({'event':'LK', 'eventCategory':'LK', 'eventAction':'click'});

                        break;

                    case 'LK':

                        dataLayer.push({'event':'Email', 'eventCategory':'Email', 'eventAction':'click', 'eventLabel':eventName});

                        break;

                }

            } catch (e) {
                console.log(e);
            }

        }

    };
    
});